// extracted by mini-css-extract-plugin
module.exports = {"responsive":"EdgeMedia_responsive__C1Ibp","fadeIn":"EdgeMedia_fadeIn__POKnA","videoThumbRoot":"EdgeMedia_videoThumbRoot__DwHFk","playButton":"EdgeMedia_playButton__3rIQZ"};